module.exports = __webpack_public_path__ + "img/inktober_2020_11_disgusting_arrow.04e648c2.jpg";